export const LOW_BROKERAGE_IMG_URL =
  "https://cms-assets.bajajfinserv.in/is/image/bajajfinance/low-brokerage-updated?scl=1";
